import React, { useEffect, useState } from 'react';
import ModalConfirmation from '../../modules/procedures/components/Modal/Modal';
import { ModalSurveysView } from './ModalSurveysView';
import useSurvey from '@/presentation/hooks/useSurvey';

type OptionType = {
  message?: string;
  message2?: string;
  messageBlack?: string;
  messageExtra?: string;
  dateBlock?: string;
};

const ModalSurveysController = () => {
  const {
    showModalSurvey,
    hideSurvey,
    surveysData,
    blocked,
    lastLimitDate,
    goToSurveys,
    closeSession
  } = useSurvey();

  const options: { [key: string]: OptionType } = {
    notRequired: {
      message: `Tienes ${surveysData?.pendingSurveys} encuesta(s) por responder.`
    },
    warningMoreThanOneDay: {
      message: `Tienes ${surveysData?.pendingSurveys} encuesta(s) para responder.`,
      message2: 'y evita la restricción de acceso a UTP+portal.',
      messageBlack: 'NPS Opinión Alumno - Docente',
      dateBlock: surveysData?.blockedDate
    },
    warningOneDay: {
      message: 'Tienes hasta hoy para completar',
      message2: 'Evita la restricción de acceso a UTP+portal.',
      messageBlack: 'NPS Opinión Alumno - Docente.'
    },
    blocked: {
      message: 'Completa la encuesta',
      message2: 'para volver a acceder a UTP+portal.',
      messageExtra: '¡Gracias por tu tiempo y colaboración!',
      messageBlack: 'NPS Opinión Alumno - Docente'
    }
  };

  const [option, setOption] = useState<OptionType | null>(null);
  const [hasRequired, setHasRequired] = useState(false);

  useEffect(() => {
    setHasRequired(surveysData?.hasRequired);
    if (blocked) setOption(options.blocked);
    else if (lastLimitDate) setOption(options.warningOneDay);
    else if (surveysData?.hasRequired) setOption(options.warningMoreThanOneDay);
    else setOption(options.notRequired);
  }, [blocked, lastLimitDate, surveysData?.hasRequired]);

  useEffect(() => {
    if (!blocked) return () => {};
    const handleContextMenu = (e: any) => {
      e.preventDefault();
    };

    const handleKeyDown = (e: any) => {
      if (e.key === 'F12' || e.ctrlKey || e.shiftKey || e.key === 'Tab') {
        e.preventDefault();
      }
    };

    document.addEventListener('contextmenu', handleContextMenu);
    document.addEventListener('keydown', handleKeyDown);

    return () => {
      document.removeEventListener('contextmenu', handleContextMenu);
      document.removeEventListener('keydown', handleKeyDown);
    };
  }, [blocked]);

  const handleVisibilityAndLocalStorage = () => {
    // titleSurvey se define en ModalSurveysView
    const titleModal = document.getElementById('titleSurvey');
    // se obtiene el atributo persist del localStorage
    const persistSurvey = localStorage.getItem('persist:survey');
    const overlayModal = document.getElementById('overlay-div');
    if (!titleModal || !persistSurvey || !overlayModal) closeSession();
  };

  const handleObserverFirstRender = () =>
    new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.type === 'childList') handleVisibilityAndLocalStorage();
      });
    });

  useEffect(() => {
    const overlay = document.getElementById('overlay-div');
    if (!blocked) {
      if (overlay) overlay.remove();
      return () => {};
    }
    const checkTitleVisibility = setInterval(() => {
      if (!overlay) {
        const obs = handleObserverFirstRender();
        obs.observe(document.body, { childList: true, subtree: true });
        obs.disconnect();
      }
      handleVisibilityAndLocalStorage();
    }, 1000);
    return () => clearInterval(checkTitleVisibility);
  }, [blocked]);

  const handleObserverStyle = (overlay: HTMLElement, lightBox: HTMLElement) =>
    new MutationObserver((mutations) => {
      const styleCondition =
        overlay.style.display === 'none' ||
        overlay.style.position !== 'fixed' ||
        lightBox.style.display === 'none' ||
        lightBox.style.visibility !== 'visible' ||
        !overlay.style.display ||
        !overlay.style.position ||
        !lightBox.style.visibility;
      mutations.forEach((mutation) => {
        if (
          mutation.type === 'attributes' &&
          mutation.attributeName === 'style' &&
          styleCondition &&
          blocked
        )
          closeSession();
      });
    });

  // integración de div overlay para restringir funcionalidades en caso de manipulación
  useEffect(() => {
    let overlay = document.getElementById('overlay-div');
    const lightBox = document.querySelector(
      '[data-testid="cmp-LightBox"]'
    ) as HTMLElement;
    // se crea el overlay
    if (blocked) {
      if (!overlay) {
        overlay = document.createElement('div');
        overlay.id = 'overlay-div';
        document.body.appendChild(overlay);
      }
      Object.assign(overlay.style, {
        position: 'fixed',
        top: '0',
        left: '0',
        width: '100%',
        height: '100%',
        zIndex: '998',
        display: 'block'
      });
    } else if (overlay) {
      overlay.style.display = 'none';
      overlay.remove();
    }
    if (!overlay) return () => {};
    // observador para detectar cambios de estilo
    const observer = handleObserverStyle(overlay, lightBox);
    if (blocked) {
      observer.observe(overlay, { attributes: true });
    }
    return () => {
      observer.disconnect();
      if (overlay) overlay.remove();
    };
  }, [blocked]);

  if (!surveysData || surveysData?.pendingSurveys < 1 || !option) return null;

  return (
    <div id="modalSurvey" style={{ zIndex: 1000, position: 'relative' }}>
      <ModalConfirmation
        show={showModalSurvey}
        handleClose={blocked ? undefined : hideSurvey}
      >
        <ModalSurveysView
          handlerClose={hideSurvey}
          option={option}
          hasRequired={hasRequired}
          isBlocked={blocked}
          goTo={goToSurveys}
        />
      </ModalConfirmation>
    </div>
  );
};

export default ModalSurveysController;
